<template lang="pug">
  section
    b-container
      h1.mt-0(v-if="this.rental") {{ `Rental #${rental.id}` }}
      .breadcrumbs.text-muted.small.py-3
        router-link(:to="{name: 'Rentals'}")
          font-awesome-icon.mr-2(icon="chevron-left")
          span ALL RENTALS
      content-loader(:height="7", v-if="alert.loading")
      .row(v-else-if="rental")
        .col-12
          b-card.mt-3
            .container
              .row
                .col-6
                  h4 Summary
                  p Details
                  ul.list-unstyled
                    li
                      span.font-weight-bold Rental
                      span.ml-1 {{ `#${rental.id}` }}
                      li
                      span.font-weight-bold Status
                      b-badge.ml-2(variant="dark") {{ rental.status }}
                    li
                      span.font-weight-bold Piece
                      span.ml-1 {{ rental.art_title }}
                    li
                      span.font-weight-bold Customer
                      span.ml-1 {{ rental.customer_name }}
                    li
                      span.font-weight-bold Piece
                      span.ml-1 {{ rental.art_title }}
                    li
                      span.font-weight-bold Start
                      span.ml-1 {{ rental.date_start_pretty }}
                    li
                      span.font-weight-bold End
                      span.ml-1 {{ rental.date_end_pretty }}
                    li
                      span.font-weight-bold Contract period
                      span.ml-1 {{ rental.contract_period }}
                    li
                      span.font-weight-bold Listed value
                      span.ml-1 {{ rental.art_value }}
                    li
                      span.font-weight-bold Discount rate
                      span.ml-1 {{ `${rental.discount_rate*100}%` }}
                    li
                      span.font-weight-bold Qualifying spend
                      span.ml-1 {{ formatRandsCents(rental.rental_spend) }}
                    li
                      span.font-weight-bold Rebate rate
                      span.ml-1 {{ `${Math.round(rental.conversion_discount_rate)}%` }}
                    br
                    li
                      span.font-weight-bold Conversion price
                      span.ml-1 {{ formatRandsCents(rental.conversion_price) }}
                .col-md-6
                  h4 Actions
                  p Please select
                  ul
                    li(v-if="rental.status == 'active'")
                      a(@click="cancelRental()") Cancel rental
                    li(v-else-if="rental.status == 'cancelled'")
                      a(@click="returnRental()") Mark as returned
                    li(v-if="['active', 'cancelled'].includes(rental.status)")
                      a(@click="convertRental()") Convert to sale
                    span(v-else="") Rental complete
        .col-12.pt-3
          b-card
            .container
              h4 Associated Orders
              b-table(:items="rental.orders", :fields="orderFields", @row-clicked="openRow", sort-by="id", responsive, borderless)
                template(v-slot:cell(compId)="row")
                  span {{ row.item.id }}
                template(v-slot:cell(compType)="row")
                  b-badge() {{ row.item.type }}
                template(v-slot:cell(compTotal)="row") {{ formatRands(row.item.total) }}
                template(v-slot:cell(compPeriod)="row") {{ `${row.item.date_start_pretty} - ${row.item.date_end_pretty}` }}
                template(v-slot:cell(compStatus)="row")
                  b-badge(:variant="row.item.status==='completed'?'dark':'light'") {{ row.item.status }}
      p(v-else="") Rental not found
</template>

<script>

import { apiService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'Rental',
  mixins: [standardMix],
  data() {
    return {
      rental: null,
      rentalFields: [
        { key: 'art_title', label: 'Piece', sortable: true },
        { key: 'artist_name', label: 'Artist' },
        { key: 'compValue', label: 'Value' },
        // { key: 'actions', label: '' },
      ],
      orderFields: [
        { key: 'compId', label: 'Order' },
        { key: 'compType', label: 'Type' },
        { key: 'compPeriod', label: 'Period' },
        { key: 'compTotal', label: 'Total' },
        { key: 'compStatus', label: 'Status' },
      ],
    };
  },
  computed: {
  },
  methods: {
    async cancelRental() {
      try {
        await apiService.cancelRental(this.rental.id);
        this.rental.status = 'cancelled';
        this.success('Rental cancelled');
      } catch (error) {
        this.error('Could not cancel rental');
      }
    },
    async returnRental() {
      try {
        await apiService.returnRental(this.rental.id);
        this.rental.status = 'returned';
        this.success('Rental returned');
      } catch (error) {
        this.error('Could not return rental');
      }
    },
    async convertRental() {
      try {
        await apiService.convertRental(this.rental.id);
        this.rental = await apiService.getRental(this.$route.params.rentalId);
        this.success('Rental converted');
      } catch (error) {
        this.error('Could not convert rental');
      }
    },
  },
  async created() {
    if (this.$route.params.rentalId) {
      try {
        this.loading();
        this.rental = await apiService.getRental(this.$route.params.rentalId);
        this.clear();
      } catch (error) {
        this.error('Rental not found');
      }
    }
  },
};
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/Rental.vue